import { LocalStorage } from "./LocalStorage";
import { StorageManager } from "./StorageManager";
import { VoiceOrderHandoffStorageSerializer, } from "./VoiceOrderHandoffStorageSerializer";
/**
 * The cart-continuation page (/kontynuuj-koszyk/:token) stores the handoff before redirecting.
 * It is read before the client is created, because the sales channel fixes menu prices at parse time.
 */
export class VoiceOrderHandoffStorageManager {
    constructor() { }
    static getInstance(storage) {
        if (storage !== undefined) {
            return VoiceOrderHandoffStorageManager.create(storage);
        }
        if (VoiceOrderHandoffStorageManager.instance === undefined) {
            VoiceOrderHandoffStorageManager.instance =
                VoiceOrderHandoffStorageManager.create(LocalStorage.create());
        }
        return VoiceOrderHandoffStorageManager.instance;
    }
    static create(storage) {
        return new StorageManager({
            storage,
            storageKey: VoiceOrderHandoffStorageManager.storageKey,
            storageSerializer: new VoiceOrderHandoffStorageSerializer(),
        });
    }
    /**
     * Token of the handoff for this restaurant while it is still valid, otherwise null.
     * An expired handoff is erased.
     */
    static validToken(restaurantId, now = new Date(), storage) {
        const manager = VoiceOrderHandoffStorageManager.getInstance(storage);
        const handoff = manager.restore();
        if (handoff === null) {
            return null;
        }
        if (Date.parse(handoff.expiresAt) <= now.getTime()) {
            manager.erase();
            return null;
        }
        if (handoff.restaurantId !== restaurantId) {
            return null;
        }
        return handoff.token;
    }
    static erase(storage) {
        VoiceOrderHandoffStorageManager.getInstance(storage).erase();
    }
}
VoiceOrderHandoffStorageManager.storageKey = "client_voiceOrderHandoff";
